const roundGolfStat = (value: unknown) => {
  if (typeof value !== 'number') return '-';
  return Math.round(value);
};

const toFixedGolfStat = (value: unknown, precision = 2) => {
  if (typeof value !== 'number') return '-';
  return value.toFixed(precision);
};

export { roundGolfStat, toFixedGolfStat };
